import { ReactNode } from "react";

import { classNames } from "../../lib/utils/css";

type GridProps = {
  className?: string;
  children?: ReactNode;
};

function Grid(props: GridProps) {
  return (
    <div
      className={classNames(
        "grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-x-8",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}

export default Grid;
